"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var __exports_1 = require("../../../__exports");
/* istanbul ignore next */
var RadioGroupSection = function (props) { return (React.createElement(__exports_1.default.RadioButton, { selectedValue: props.selectedValue, items: props.options || [], onChange: props.onRadioButtonClick })); };
exports.default = RadioGroupSection;
//# sourceMappingURL=RadioGroupSection.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/filter-sections/build/control/components/RadioGroupSection/RadioGroupSection.js
// module id = 740
// module chunks = 0